"use strict";

exports.__esModule = true;
exports["default"] = size;

function size(height, width) {
  if (width === void 0) {
    width = height;
  }

  return {
    height: height,
    width: width
  };
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./~/polished/lib/shorthands/size.js
// module id = 1047
// module chunks = 27180705640166